
import * as React from 'react';
import { ICommand } from '../../../../models/commands/ICommand';
import { RetryProgressAction } from '../../actions/retry/RetryProgressAction';
import { Facet } from '../../../../models/Facet';
import ProgressStrings from '../../ProgressStrings.resx';

export const retryProgressCommand: ICommand = {
  key: new Facet('retryProgressCommand').id,
  name: ProgressStrings.progressRetryActionText,
  action: <RetryProgressAction />
};
